import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from "prop-types";
import Header2 from "../components/header/Header2";
import Footer from "../components/footer";
import Breadcrumb from "../components/breadcrumb";
import CategorySec1 from "../components/blog/CategorySec";
import dataBlog from "../assets/fakeData/dataBlog";
import Gotop from "../components/gotop";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import httpService from "../services/httpService";

const HomeNews = () => {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  // categories for homepage news
  const [topNewsData, setTopNewsData] = useState([]);
  const [LIUData, setLIUData] = useState([]);
  const [ILRData, setILRData] = useState([]);
  const [countriesData, setCountriesData] = useState([]);
  const [familyClassData, setFamilyClassData] = useState([]);
  const [UKCitiesData, setUKCitiesData] = useState([]);
  const [UKWorkData, setUKWorkData] = useState([]);
  const [UKStudyData, setUKStudyData] = useState([]);
  const [UKVisitData, setUKVisitData] = useState([]);
  const [UKSettlingData, setUKSettlingData] = useState([]);
  const [articles, setArticles] = useState([]);

  const [loader, setLoader] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const category = window.location.pathname.split("/").pop();

  const result = category.includes("-")
    ? category.replace(/-/g, " ").replace(/^./, c => c.toUpperCase())
    : category.charAt(0).toUpperCase() + category.slice(1);

  const getNews = async () => {
    try {
      setLoader(true)
      const res = await httpService.get(`news/category?name=${category}`);

      if (category === "latest") {
        setArticles(res.data.data.docs);
        setLoader(false)
      } else {
        setArticles(res.data.data.news);
        setLoader(false)
      };
    } catch (err) {
      setLoader(false)
    }
  };

  const getLatestNews = async () => {
    try {
      const res = await httpService.get("news/latest/news");
      setArticles(res.data.data);
      setLoader(false);
    } catch (error) { }
  };

  useEffect(() => {
    if (category === "latest") {
      getLatestNews();
    } else {
      getNews();
    }
  }, [category]);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{`UKICNEWS - ${result}`}</title>
          <meta
            name="description"
            content={`Stay updated with UK immigration news for ${result}.`}
          />
          <link rel="canonical" href={window.location.pathname} />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`UKICNEWS | ${result}`} />
          <meta
            property="og:description"
            content={`Stay updated with UK immigration news for ${result}.`}
          />
          <meta property="og:url" content={window.location.pathname} />
          <meta property="og:image" content={"https://www.ukicnews.com/preview.png"} />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`UKICNEWS | ${result}`} />
          <meta
            name="twitter:description"
            content={`Stay updated with UK immigration news for ${result}.`}
          />
          <meta name="twitter:image" content={"https://www.ukicnews.com/preview.png"} />
        </Helmet>
      </HelmetProvider >
      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="act1" handleMobile={handleMobile} />

      <CategorySec1
        data={articles}
        category={result}
        loader={loader}
      />
      <Footer />
      <Gotop />
    </>
  );
};

export default HomeNews;
